import * as React from "react";
import { IMenuBreadCrumbsProps } from "./MenuBreadCrumbs.types";
import { Icon } from "../Icon/icon";

export class MenuBreadCrumbs extends React.Component<IMenuBreadCrumbsProps> {
  render() {
    return (
      <div className="mobile-menu__selectedpage-container">
        <div className={this.props.startPageClass}>
          {this.props.isStartPage && <div>{this.props.backIcon}</div>}

          {this.props.selectedPage}
          {this.props.isStartPage && (
            <a href="/">
              <Icon iconType="fontawesome/home" />
            </a>
          )}
        </div>
      </div>
    );
  }
}
